import { render, staticRenderFns } from "./NeedSignComfirm.vue?vue&type=template&id=1def8e82"
import script from "./NeedSignComfirm.vue?vue&type=script&lang=js"
export * from "./NeedSignComfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports